// 叫車紀錄總查詢
export const instantPick = [
  {
    id: 0,
    title: '所有來源(已派到車)',
    task: 'havecar',
    hover: '來源包含客服派車、LINE、定點APP',
  },
  {
    id: 1,
    title: '僅客服派車(含未找到司機)',
    task: 'serviceall',
    hover: '只顯示來源是客服派車的訂單',
  },
  { id: 2, title: 'App/Line叫車(找到司機)', task: 'appTeam', hover: null },
  {
    id: 3,
    title: 'App/Line叫車(未找到司機)',
    task: 'specialpassengernoncar',
    hover: null,
  },
]

// 司機資料
export const authOptions = [
  {
    value: 0,
    label: '授權',
  },
  {
    value: 1,
    label: '停權',
  },
]

// 預約派車單總表的目前進度
export const currentStatusOptions = [
  {
    value: null,
    label: '所有進度',
  },
  {
    value: 'finish',
    label: '已完成',
  },
  {
    value: 'pair',
    label: '已配對',
  },
  {
    value: 'unpair',
    label: '未配對完',
  },
  {
    value: 'getPassenger',
    label: '已載客',
  },
  {
    value: 'cancel',
    label: '已取消(乘客取消/司機取消)',
  },
  {
    value: 'nodriver',
    label: '尚未有司機接單',
  },
  {
    value: 'wait',
    label: '等候乘客選擇司機',
  },
]



// WEBPACK FOOTER //
// ./src/constants/select.js